import { ReactElement, useState } from 'react';
import cn from 'classnames';
import styles from './Accordion.module.scss';
import { Icon, IconProps } from '../Icon/Icon';
import { Button, ButtonProps } from '../Button/Button';

interface AccordionI {
  children?: ReactElement | string;
  childrenOnBar?: ReactElement | string;
  className?: string;
  title?: string;
  buttons?: {
    onClick?: (event: any) => void;
    iconType?: IconProps['type'];
    theme?: ButtonProps['btnStyle'];
    to?: string;
  }[];
  extraBars?: ReactElement[] | ReactElement | string;
}

export const Accordion = ({
  children,
  title,
  buttons,
  extraBars,
  childrenOnBar,
  className,
}: AccordionI) => {
  const [isOpen, setIsOpen] = useState(false);

  const renderbuttons = () => {
    return buttons?.map(({ iconType, onClick, ...button }) => {
      return (
        <Button
          className={styles['internal-button']}
          key={iconType}
          onClick={(event: Event) => {
            event?.stopPropagation();
            onClick?.(event);
          }}
          {...button}
        >
          <Icon type={iconType} />
        </Button>
      );
    });
  };

  return (
    <div className={cn(styles.root, isOpen && styles.open, className)}>
      <Button
        className={styles.header}
        onClick={(event: Event) => {
          setIsOpen((open) => !open);
        }}
      >
        <div className={styles['first-bar-content']}>
          <div className={styles.left}>
            <div className={styles.text}>{title}</div>
            {childrenOnBar}
            {renderbuttons()}
          </div>
          <Icon classname={styles.icon} type="right-arrow" />
        </div>
        <div className={styles['extra-bars-content']}>{extraBars}</div>
      </Button>
      <div className={cn(styles.content)}>{children}</div>
    </div>
  );
};
